import { map, slice } from "lodash";
import DropDown from "../../shared/DropDown";
import { Activitystream } from "../../../api/activitystreams.ts";

type StreamListArgs = {
  foreignActivityStreams?: any[];
  streamsFromActivity?: Activitystream[];
};

function getStreamUrl(stream: Activitystream) {
  return stream.group_slug
    ? `/groups/${stream.group_slug}/activitystreams/all`
    : `/activitystreams/${stream.slug || "all"}`;
}

export default function StreamList({
  streamsFromActivity,
  foreignActivityStreams,
}: StreamListArgs) {
  const stream = streamsFromActivity && streamsFromActivity[0];
  const streamsCount = foreignActivityStreams
    ? streamsFromActivity?.length || 0 + foreignActivityStreams?.length
    : streamsFromActivity?.length || 0;

  return (
    <div className="stream-visibility font-semibold text-sm text-normal flex gap-1 items-center">
      <a
        className="text-normal leading-none"
        href={stream && getStreamUrl(stream)}
      >
        {stream?.name}
      </a>
      {streamsCount > 1 && (
        <DropDown.Wrapper>
          {!window.isApp && <span>+</span>}
          <DropDown.Toggle
            className="more-streams-link p-0 font-semibold no-underline hover:underline"
            showIcon={false}
            buttonType="link"
            small
          >
            {window.isApp
              ? "+" + `${streamsCount - 1}`
              : I18n.t("js.activitystreams.published_in_more_streams", {
                  num: streamsCount - 1,
                })}
          </DropDown.Toggle>
          <DropDown alignment="start">
            {map(
              [
                ...slice(streamsFromActivity, 1, streamsFromActivity?.length),
                ...(foreignActivityStreams || []),
              ],
              (stream) => (
                <DropDown.Item
                  key={stream.slug}
                  title={stream.name}
                  text={stream.name}
                  url={getStreamUrl(stream)}
                />
              ),
            )}
          </DropDown>
        </DropDown.Wrapper>
      )}
    </div>
  );
}
